module.exports = __webpack_public_path__ + "media/images/img-pet-5-83450588.jpg";